import { createApp } from '@backstage/frontend-defaults';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  configApiRef,
  googleAuthApiRef,
  useApi,
  type SignInPageProps,
} from '@backstage/core-plugin-api';
import { SignInPage, type SignInProviderConfig } from '@backstage/core-components';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import authPlugin from '@backstage/plugin-auth';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import githubActionsPlugin from '@backstage-community/plugin-github-actions/alpha';
import { navModule } from './modules/nav';

const googleProvider: SignInProviderConfig = {
  id: 'google-auth-provider',
  title: 'Google',
  message: 'Sign in using your AIM Manager Google account',
  apiRef: googleAuthApiRef,
};

// Fuera de producción (yarn start local, donde el backend solo ofrece el
// provider guest) se habilita también el login guest para no requerir
// credenciales de Google en desarrollo.
const AimSignInPage = (props: SignInPageProps) => {
  const configApi = useApi(configApiRef);
  const isProduction =
    configApi.getOptionalString('auth.environment') === 'production';
  return (
    <SignInPage
      {...props}
      providers={isProduction ? [googleProvider] : ['guest', googleProvider]}
    />
  );
};

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => <AimSignInPage {...props} />,
  },
});

export default createApp({
  features: [
    catalogPlugin,
    authPlugin,
    kubernetesPlugin,
    githubActionsPlugin,
    navModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
  ],
});
